module.exports = __webpack_public_path__ + "static/img/szafa_dso_42.fc37add.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/szafa_dso_42.svg
// module id = ffWw
// module chunks = 1